const getValue = (viewId, element) => {
  if (element.id === 'accountDetails') {
    if (viewId === 'patientDetails') {
      return '{{accountDetails}} {{accountLinkSeparator}} <a href="javascript:void(0)" class="ccl__email-verified" id="pt_invite_link_{{accountId}}" data-id="{{accountId}}" data-analytics="send_invite_patient_view_patient">{{emailVerified}}</a>';
    }
    if (viewId === 'associatedCarersView') {
      return '{{accountDetails}} {{accountLinkSeparator}} <a href="javascript:void(0)" class="ccl__email-verified" id="cr_invite_link_{{accountId}}" data-id="{{accountId}}" data-analytics="send_invite_carer_view_patient">{{emailVerified}}</a>';
    }
  }
  return element.value.value;
};

export const panelConfigMapper = (
  config,
  uDetails,
  handleEditPatient,
  handleCreateCarer,
  handleAddAssociatedClinic,
) => {
  return {
    handleQueryParams: () => {},
    errorFormView: '',
    isError: false,
    errorMode: '',
    theme: 'coolgrey',
    tabsData: {
      accountId: '',
      userId: null,
      labels: {
        promptText: '',
        promptTextAbbrv: '...',
        type: '',
      },
      tabs: [
        {
          firstName: '',
          lastName: '',
          tabIndex: 0,
          type: '',
          userId: '',
        },
      ],
    },
    views: config.views.map((view) => ({
      country: uDetails.countryCode,
      language: uDetails.languageCode,
      mask: view.mask.value,
      id: view.id.value,
      title: view.title?.targetItem?.key.key,
      fallbackTitle: view.fallbackTitle?.targetItem?.key.key,
      type: view.type.value,
      mode: view.mode.value,
      showGlobalAdd: view.showGlobalAdd?.value === '1',
      data: view.data.value,
      showEditIcon: view.showEditIcon.value === '1',
      showAddIcon: view.showAddIcon.value === '1',
      isLoading: true,
      // if this is false, then the screen tries to go into edit mode and throws an error
      removeViewSwitch: true,
      onEditHandle: () => {
        handleEditPatient();
      },
      // does not seem to exist in cds
      onCreateHandle: function onCreateHandle() {},
      // only this is used, so this needs to distinguish between carers and clinics
      onGlobalCreateHandle: () => {
        if (view.id.value === 'associatedCarersView') {
          handleCreateCarer();
        } else {
          handleAddAssociatedClinic();
        }
      },
      read: {
        name: view.read[0]?.name.value,
        clkErrorLabel:
          view.read[0]?.clkErrorLabel?.targetItem?.key.key,
        errorLabel: view.read[0]?.errorLabel?.targetItem?.key.key,
        fieldLayout: 'horizontal',
        elements: view.read[0]?.elements.map((element) => ({
          id: element.id,
          label: element.label?.targetItem?.key.key,
          value: getValue(view.id.value, element),
          validators: [],
        })),
        analytics: view.read[0]?.analytics,
        fields: [],
      },
      editLabel: view.edit[0]?.edit?.targetItem?.key.key,
      createLabel: view.create[0]?.createLabel?.targetItem?.key.key,
      edit: {
        edit: view.edit[0]?.edit?.targetItem?.key?.key,
        editIcon: view.edit[0]?.editIcon?.value,
        analytics: view.edit[0]?.analytics,
      },
      create: {
        createLabel: view.create[0]?.createLabel?.targetItem?.key.key,
        createIcon: view.create[0]?.createIcon.value,
      },
    })),
    errorView: {
      codeLabel: 'Error code',
      errorResponse: '',
      mode: '',
      data: {
        submit: {
          image: {
            src: 'https://mss-p-007-delivery.sitecorecontenthub.cloud/api/public/content/9bfd65ed69994fa49be3ff1339ea9674?v=cc7c6ec3',
            alt: 'Bug.svg',
            width: '120',
          },
          title: "That's strange, it seems something went wrong.",
          text: 'We had a problem updating your details.<br />If you need immediate help, contact our customer support team on <a href="tel:+1-877-651-7001" class="ccl__text--interactive-text" data-nw-error-link="phoneNumber" data-nw-action="call">877-651-7001.</a>',
          buttons: [
            {
              name: 'tryAgain',
              variant: 'brand-primary',
              text: 'Try again',
              icon: '',
              link: '',
              action: 'retry-submit',
              useCallback: true,
            },
            {
              name: 'backToHome',
              variant: 'secondary',
              text: 'Cochlear home',
              icon: 'chevron-right',
              link: 'https://node.sit.cms.cochlear.cloud/us/en/home',
              action: 'link-cochlear-home',
              useCallback: false,
            },
          ],
        },
        read: {
          image: {
            src: 'https://mss-p-007-delivery.sitecorecontenthub.cloud/api/public/content/9bfd65ed69994fa49be3ff1339ea9674?v=cc7c6ec3',
            alt: 'Bug.svg',
            width: '120',
          },
          title: "That's strange, it seems something went wrong.",
          text: 'We’re working to fix the problem and we’ll be up and running soon.<br />If you need immediate help, contact our customer support team on <a href="tel:+1-877-651-7001" class="ccl__text--interactive-text" data-nw-error-link="phoneNumber" data-nw-action="call">877-651-7001.</a>',
          buttons: [
            {
              name: 'backToHome',
              variant: 'secondary',
              text: 'Cochlear home',
              icon: 'chevron-right',
              link: '/us/en/home',
              action: 'link-cochlear-home',
              useCallback: false,
            },
          ],
        },
      },
    },
    token: '',
    popOverPrompt: {
      showPopOverPrompt: false,
      popOverPromptText: '',
      storage: {
        check: 'exists',
        method: 'session',
        name: 'carerPrompt',
        value: 1,
      },
    },
  };
};

export const getCarerReadElementsConfig = (config) => {
  const viewId = 'associatedCarersView';
  const viewIndex = config.views.findIndex(
    ({ id }) => id.value === viewId,
  );

  const carerViewElements =
    config.views[viewIndex]?.read[0]?.elements;
  return carerViewElements.map((element) => ({
    id: element.id,
    label: element.label?.targetItem?.key.key,
    value: getValue(viewId, element),
    validators: [],
  }));
};
